import * as React from 'react'
import usePagination from '@mui/material/usePagination'
import { Button, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import AdxButton from 'components/custom/AdxButton'

const List = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export default function FormPagination({
  pageCount,
  pageCurrent,
  handlePage,
  handleExit,
  isPreview,
  isSubmission,
  handleSubmit,
}) {
  const { items } = usePagination({
    count: pageCount,
    hideNextButton: pageCurrent + 1 === pageCount ? true : false,
    boundaryCount: 99,
    siblingCount: 99,
  })

  React.useEffect(() => {
    let test = items.find((i) => i.selected === true)
    handlePage(test.page)
  }, [items])

  return (
    <nav>
      <List>
        {items.map(({ page, type, selected, ...item }, index) => {
          let children = null

          if (type === 'start-ellipsis' || type === 'end-ellipsis') {
            children = '…'
          } else if (type === 'page') {
            children = (
              <Button
                sx={{
                  fontWeight: selected ? 'bold' : undefined,
                  backgroundColor: page <= pageCurrent + 1 ? '#1CBA98' : '#F7F9FA',
                  width: `calc(50vw/${pageCount})`,
                  height: '15px',
                  margin: '0px 10px',
                  borderRadius: '15px',
                  border: 'none',
                }}
                {...item}
              ></Button>
            )
          } else if (type === 'previous') {
            children = (
              <AdxButton
                variant={'contained'}
                sx={{ width: 110, height: 50, marginRight: '70px', borderRadius: '8.25px' }}
                size="small"
                {...item}
              >
                <ArrowBackIcon />
              </AdxButton>
            )
          } else if (type === 'next') {
            children = (
              <AdxButton
                variant={'contained'}
                sx={{ width: 200, height: 50, marginLeft: '70px', borderRadius: '8.25px' }}
                size="small"
                {...item}
              >
                <Typography variant="h4" sx={{ marginRight: '15px' }}>
                  Next
                </Typography>
                <ArrowForwardIcon />
              </AdxButton>
            )
          }

          return <li key={index}>{children}</li>
        })}
        {pageCurrent + 1 === pageCount && isPreview ? (
          <AdxButton
            variant={'contained'}
            sx={{ width: 200, height: 50, marginLeft: '70px', borderRadius: '8.25px' }}
            size="small"
            onClick={() => handleExit()}
          >
            <Typography variant="h4" sx={{ marginRight: '15px' }}>
              End preview
            </Typography>
          </AdxButton>
        ) : pageCurrent + 1 === pageCount && isSubmission ? (
          <AdxButton
            variant={'contained'}
            sx={{ width: 200, height: 50, marginLeft: '70px', borderRadius: '8.25px' }}
            size="small"
            onClick={handleSubmit}
          >
            <Typography variant="h4" sx={{ marginRight: '15px' }}>
              Submit
            </Typography>
          </AdxButton>
        ) : null}
      </List>
    </nav>
  )
}
